import React, { useEffect, useState, useRef } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import createRegCss from "../../css/createregister.module.css";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Loader2 from "../../elements/Loader2";
import Dropdown from "../../elements/Dropdown";
import { useHistory, useParams } from "react-router";
import { createInvestmentRegisterApiHandler, createInvestmentRegister } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as DownArrow } from "../../assets/icons/down-arrow.svg";

const CreateInvestmentRegister = (props) => {
  let companyOptions = props.companyOptions;
  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(null);
  const [company, setCompany] = useState(null);
  const [asOnDate, setAsOnDate] = useState(null);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const dropdownRef = useRef(null);

  const DROPDOWN_MAX_HEIGHT = 230;

  useEffect(() => {
    console.log("company", company);
  }, [company]);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const createRegister = () => {
    if (!regName) {
      toast.error("Please enter register name");
      return;
    }
    if (selectedCompanies.length === 0) {
      toast.error("Please select at least one company");
      return;
    }

    const payload = {
      name: regName,
      linkedCompanies: selectedCompanies.map((c) => c.value),
    };

    console.log("Payload →", payload);
    setLoader(true);

    createInvestmentRegister(payload)
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.success) {
          swal("Success", response.data.message || "Investment register created successfully", "success");
          const registerId = response.data.investmentRegister._id;
          history.push(`/detailsIR/${registerId}`);
        }
      })
      .catch((error) => {
        console.error(error);
        swal(
          "Error",
          error?.response?.data?.message || "Unable to create register",
          "error"
        );
      })
      .finally(() => setLoader(false));
  };

  const allSelected =
    companyOptions.length > 0 &&
    selectedCompanies.length === companyOptions.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedCompanies([]);
    } else {
      setSelectedCompanies([...companyOptions]);
    }
  };

  return (
    <>
      {loader && <Loader2 />}
      <div className={createRegCss.alignForm}>
        <div className={createRegCss.container2}>
          <div className={`${commoncss.dFlex} mb-3`} style={{ marginTop: "30px" }}>
            <div className={commoncss.dFlexClm} style={{ alignItems: "center" }}>
              <span className={createRegCss.heading1}>
                Create Investment Register
              </span>
              <span className={createRegCss.label1}>
                Give your register a name and tag it to a company
              </span>
            </div>
          </div>

          <div className={`${createRegCss.container3} mt-3 mb-1`}>
            <InputGroup
              label="Name of Investment Register"
              inputs={[
                <input
                  key="reg-name"
                  name="invreg_name"
                  placeholder="Placeholder Text"
                  type="text"
                  value={regName}
                  onChange={(e) => setRegName(e.target.value)}
                  style={{ height: "35px" }}
                />,
              ]}
            />

            <div className="mt-3" style={{ width: "100%" }}>
              <label
                style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#444",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                Select Linked Companies
              </label>

              <div
                ref={dropdownRef}
                style={{
                  position: "relative",
                  paddingBottom: dropdownOpen
                    ? `${DROPDOWN_MAX_HEIGHT + 10}px`
                    : "0px",
                  transition: "padding-bottom 0.15s",
                }}
              >
                {/* Trigger */}
                <div
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => setDropdownOpen((o) => !o)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 12px",
                    border: "1px solid #C2E6D1",
                    borderRadius: "6px",
                    backgroundColor: "#F4FAF5",
                    cursor: "pointer",
                    height: "35px",
                    position: "relative"
                  }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                      display: "block",
                      color:
                        selectedCompanies.length === 0 ? "#B3C0BD" : "#000",
                    }}
                  >
                    {selectedCompanies.length === 0
                      ? "Select Company"
                      : selectedCompanies.map((c) => c.label).join(", ")}
                  </span>
                  <DownArrow
                    style={{
                      transform: dropdownOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />

                  {showTooltip && !dropdownOpen && selectedCompanies.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        marginTop: "8px",
                        backgroundColor: "#000000",
                        color: "#ffffff",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        fontSize: "14px",
                        width: "100%",
                        boxSizing: "border-box",
                        zIndex: 1000,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        lineHeight: "1.4"
                      }}
                    >
                      {selectedCompanies.map((c) => c.label).join(", ")}
                    </div>
                  )}
                </div>

                {/* Dropdown panel */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% - " + DROPDOWN_MAX_HEIGHT + "px)",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #C2E6D1",
                      borderRadius: "10px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                      zIndex: 9999,
                      maxHeight: `${DROPDOWN_MAX_HEIGHT}px`,
                      overflowY: "auto",
                    }}
                  >
                    {/* Select All — inside dropdown, only visible when open */}
                    <div
                      onClick={handleSelectAll}
                      style={{
                        padding: "10px 14px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontWeight: 600,
                        fontSize: "13px",
                        background: "#ffffff",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        borderBottom: "1px solid #C2E6D1",
                      }}
                    >
                      <input
                        type="checkbox"
                        readOnly
                        checked={allSelected}
                        style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                      />
                      Select all companies
                    </div>

                    {companyOptions.map((opt) => {
                      const selected = selectedCompanies.some(
                        (v) => v.value === opt.value
                      );
                      return (
                        <div
                          key={opt.value}
                          onClick={() => {
                            if (selected)
                              setSelectedCompanies(
                                selectedCompanies.filter(
                                  (v) => v.value !== opt.value
                                )
                              );
                            else
                              setSelectedCompanies([
                                ...selectedCompanies,
                                opt,
                              ]);
                          }}
                          style={{
                            padding: "10px 14px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "13px",
                            background: selected ? "#fff" : "#fff",
                          }}
                        >
                          <input
                            type="checkbox"
                            readOnly
                            checked={selected}
                            style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                          />
                          {opt.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Outside Select All — hidden when dropdown is open */}
              {!dropdownOpen && (
                <div
                  onClick={handleSelectAll}
                  style={{
                    padding: "10px 0",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontWeight: 500,
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={allSelected}
                    style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                  />
                  Select all companies
                </div>
              )}


              {selectedCompanies.length > 0 && (
                <div
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    background:
                      selectedCompanies.length > 3 ? "#f8f9f9" : "#ffffff",
                    padding: "10px",
                    borderRadius: "10px",
                    border:
                      selectedCompanies.length > 3
                        ? "1px solid #e0e0e0"
                        : "none",
                    width: "100%",
                    boxSizing: "border-box",
                    marginTop: "10px"
                  }}
                >
                  {selectedCompanies.map((opt) => (
                    <div
                      key={opt.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "5px 10px",
                        border: "1px solid #C2E6D1",
                        borderRadius: "6px",
                        background: "#fff",
                        fontSize: "13px",
                      }}
                    >
                      {opt.label}
                      <span
                        onClick={() =>
                          setSelectedCompanies(
                            selectedCompanies.filter(
                              (v) => v.value !== opt.value
                            )
                          )
                        }
                        style={{ cursor: "pointer", lineHeight: 1 }}
                      >
                        ✕
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div
              className="mt-4"
              style={{ width: "70%", placeSelf: "center", marginTop: "24px" }}
              onClick={createRegister}
            >
              <button
                type="submit"
                className={buttoncss.primary}
                style={{
                  padding: "7px",
                  width: "100%",
                  borderRadius: "12px",
                  marginTop: "20px",
                }}
              >
                Create Investment Register
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateInvestmentRegister;